module.exports = __webpack_public_path__ + "static/media/mosquitoe.6674a405.svg";